import { Link } from "react-router-dom";
import "../App.css";

/** Prominent “Back to dashboard” strip (main provisioning home at `/`). `label` overrides the link text. */
const PageBackBar = ({ to = "/", label = "Back to dashboard" }: { to?: string; label?: string }) => {
  return (
    <nav className="page-back-strip" aria-label="Section navigation">
      <Link to={to} className="page-back-strip-link">
        <span className="page-back-strip-icon" aria-hidden>
          <svg
            className="page-back-strip-arrow"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 18l-6-6 6-6"
              stroke="currentColor"
              strokeWidth="1.75"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
        <span>{label}</span>
      </Link>
    </nav>
  );
};

export default PageBackBar;
